export default __webpack_public_path__ + "static/media/chani anxious.3ccffb0d.svg";